import resources from "../../resources";

const WebstarsResource = resources.webstars; 
export class Handler {
  static IFrameLoadCB = null;

  static isReady = false;
  static isModelLoggedInIframeCallback = ()=>{};

  static clearIframeLoadData() {
    this.isReady = false;
    this.isModelLoggedInIframeCallback = ()=>{};
  }

  static login(data) {
    if (!Handler.IFrameLoadCB) return;
    Handler.IFrameLoadCB(WebstarsResource.LoginURL(data));
  }

  static logout() {
    if (!Handler.IFrameLoadCB) return;
    return Handler.IFrameLoadCB(WebstarsResource.LogoutURL());
  };

}
